import React from 'react'
import PropTypes from 'prop-types'
import { 
  CaseStudiesMain,
  CaseStudyMain,
  CaseStudyContainer,
  CaseStudyContent,
  CaseStudyImage,
  CaseStudiesFooter,
  IconContainer
} from './index.style'
import Container from '@components/Container'
import { Caption, Heading2Serif, Heading4Serif } from '@components/TextStyles'
import Spacer from '@components/Spacer'
import PageTransitionLink from '@components/PageTransitionLink'
import RichText from '@components/RichText'
import AnimateSplitText from '@components/animation/AnimateSplitText'
import IconArrowRight from '@svgs/IconArrowRight'
import { GatsbyImage } from 'gatsby-plugin-image'
import CMSButton from '@components/CMSButton'

const CaseStudies = ({ items }) => {
  const link = {
    text: "View more work",
    url: "/our-work"
  }
  return (
    <CaseStudiesMain>
      <Container>
        <Spacer size={[60, 110]} />

        <Heading2Serif as="h2" maxWidth={11}>
          <AnimateSplitText enterFrom="left">Our work together</AnimateSplitText>
        </Heading2Serif>

        <Spacer size={[20, 80]} />

        {React.Children.toArray(
          items.map(item => (
            <CaseStudyMain className="list">
              <PageTransitionLink to={`our-work/${item.slug}`} className="caseStudyImageLink">
                  <CaseStudyContainer className="caseStudyContainer">
                      <CaseStudyContent className='content'>
                          <Heading4Serif as="h2" maxWidth={11.3369565217}><strong>{item.title}</strong></Heading4Serif>
                          {item.heroText &&
                            <RichText
                                content={item.heroText}
                                paragraphSize="heading4Serif"
                                className="title"
                            />
                          }
                          {(item.metadata.tags.length > 0) && 
                              <>
                              <Spacer size={[15, 40]} />
                              <Caption>
                              {(item.metadata.tags[0].name.split(': ').length > 1) ? item.metadata.tags[0].name.split(': ')[1]: item.metadata.tags[0].name}
                              </Caption>
                              </>
                          }

                      </CaseStudyContent>
                      {item.mainImage && 
                          <CaseStudyImage className="caseStudyImage">
                              <GatsbyImage
                                  image={item.mainImage.gatsbyImageData}
                                  alt={item.mainImage.description}
                              />
                          </CaseStudyImage>
                      }
                      <IconContainer><IconArrowRight /></IconContainer>
                  </CaseStudyContainer>
              </PageTransitionLink>
          </CaseStudyMain>
          ))
        )}

        <Spacer size={[60, 120]} />
        <CaseStudiesFooter>
            {link && (
              <>
                <CMSButton
                  link={link}
                  variant="text"
                  iconRight={<IconArrowRight />}
                />
              </>
            )}
        </CaseStudiesFooter>
        <Spacer size={[60, 120]} />
      </Container>
    </CaseStudiesMain>
  )
}

CaseStudies.propTypes = {
  items: PropTypes.array,
}

export default CaseStudies
